// Components
import { RootState } from '../index';

const getAssignment = (state: RootState) => state.assignmentDataSlice.assignments;

export {
  getAssignment,
};
